import * as React from "react";
import { cn } from "@/lib/utils";

type MetricTileVariant = "default" | "success" | "info" | "warning";

interface MetricTileProps {
  label: string;
  value: string | number;
  subLabel?: string;
  description?: string;
  trend?: string;
  variant?: MetricTileVariant;
  testId?: string;
  className?: string;
}

const variantStyles: Record<MetricTileVariant, string> = {
  default: "bg-slate-50 border-slate-200 text-slate-900",
  success: "bg-emerald-50 border-emerald-100 text-emerald-800",
  info: "bg-sky-50 border-sky-100 text-sky-800",
  warning: "bg-amber-50 border-amber-100 text-amber-800",
};

export function MetricTile({
  label,
  value,
  subLabel,
  description,
  trend,
  variant = "default",
  testId,
  className,
}: MetricTileProps) {
  const classes = variantStyles[variant];
  
  return (
    <div
      className={cn(
        "rounded-2xl border shadow-sm px-4 py-3 flex flex-col gap-1 coach-metric-card",
        classes,
        className
      )}
      data-testid={testId}
    >
      <div className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</div>
      <div className="text-2xl font-semibold leading-tight">{value}</div>
      {(description || subLabel || trend) && (
        <div className="text-xs text-slate-500">{description || subLabel || trend}</div>
      )}
    </div>
  );
}
